// extracted by mini-css-extract-plugin
export default {"tag":"PriorityTag_tag__Kko-g","low":"PriorityTag_low__D8Q33","mid":"PriorityTag_mid__ngQbV","high":"PriorityTag_high__WdJwF"};